import React from "react"
import Layout from "../component/layout"
export default () => (
  <Layout>
    <h1>You wanna know about me???</h1>
    <h2>I'm sick as hell</h2>
  </Layout>
  )